"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RecordingUsage = (props) => (react_1.default.createElement("p", { className: 'source-container' }, props.recordings
    .map((rec) => rec.usageSource)
    .filter((src) => src != null)
    .reduce((prevSrc, curSrc) => (!prevSrc.length || prevSrc[0] === curSrc ? [curSrc] : ['mixed']), [])
    .flatMap((src) => (src === 'historic' ? ['H'] : src === 'regular' ? ['B'] : ['B', 'H']))
    .map((char) => (react_1.default.createElement("span", { key: props.recordingGroupId + char, className: 'source-char' }, char)))));
exports.default = RecordingUsage;
